const rowsCalculationInProgress = new Set<string>()
const columnsCalculationInProgress = new Set<string>()

export const isRowsCalculationInProgress = (compId: string): boolean => rowsCalculationInProgress.has(compId)

export const isColumnsCalculationInProgress = (compId: string): boolean => columnsCalculationInProgress.has(compId)

export const runWithRowsCalculationInProgress = (compId: string, fn: () => void): void => {
    rowsCalculationInProgress.add(compId)
    try {
        fn()
    } finally {
        rowsCalculationInProgress.delete(compId)
    }
}

export const runWithColumnsCalculationInProgress = (compId: string, fn: () => void): void => {
    columnsCalculationInProgress.add(compId)
    try {
        fn()
    } finally {
        columnsCalculationInProgress.delete(compId)
    }
}
